module.exports = __webpack_public_path__ + "img/plus.83f6e64e.svg";